var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#424F62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1609 623.64L1615.32 617.32 1609 611",
    transform: "translate(-1605 -613) scale(1 -1) rotate(90 2229.48 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCopy);
export default __webpack_public_path__ + "static/media/arrow-copy.fe9a9eb65d6740fa0b2493336d29dc64.svg";
export { ForwardRef as ReactComponent };